import React from 'react'
import { connect } from 'react-redux'
import { selectDeviceTypeIsMobile } from 'selectors/app'
import { doMentionAgent } from 'actions/tickets'
import MobileMentionSelector from './Mobile'
import DesktopMentionSelector from './Desktop'

const select = state => ({
  deviceTypeIsMobile: selectDeviceTypeIsMobile(state),
})

const perform = {
  doMentionAgent,
}

const MentionSelector = props => {
  const { deviceTypeIsMobile } = props

  if (!deviceTypeIsMobile) return <DesktopMentionSelector {...props} />

  return <MobileMentionSelector {...props} />
}

export default connect(select, perform)(MentionSelector)
